export type  EventPrivateSelect = {
  label: "Закрытое" | "Открытое"
  value: boolean
}
export type EventPrivateSelectList = Array<EventPrivateSelect>

export const EventModeVariants = [
  { value: false, label: "Открытое" },
  { value: true, label: "Закрытое" }
]
